var map = {
	"./Ellipse 95.png": 8603,
	"./Group 371.png": 6143,
	"./Rectangle 1.png": 9039,
	"./Rectangle 2.png": 8477,
	"./appStore.png": 8848,
	"./arrowIcon.png": 7174,
	"./blueBox.png": 7968,
	"./colorfulBoxes.png": 7010,
	"./crossIcon.png": 7447,
	"./features1.png": 9061,
	"./features2.png": 6186,
	"./features3.png": 9294,
	"./features4.png": 4328,
	"./features5.png": 6865,
	"./features6.png": 3662,
	"./headerImage.png": 2645,
	"./headerImage@bkp.png": 8654,
	"./logo.png": 6949,
	"./particles.png": 2614,
	"./pinkBox.png": 7148,
	"./playStore.png": 4102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2594;